"use client"

import { useEffect } from "react"

import { revealObserver } from "@/lib/hooks/use-reveal"

// Mounted once per page so server components can opt a block into the scroll
// arrival with a class alone, instead of every one of them becoming a client
// boundary. The mutation watch is what makes it work on the PDP, whose rails
// stream in behind Suspense long after this has mounted.
export const RevealScope = () => {
  useEffect(() => {
    const observer = revealObserver()
    if (!observer) {
      for (const node of document.querySelectorAll(".reveal")) node.setAttribute("data-in", "")
      return
    }
    const adopt = (root: ParentNode) => {
      for (const node of root.querySelectorAll(".reveal:not([data-in])")) observer.observe(node)
    }
    adopt(document)
    let frame = 0
    const mutations = new MutationObserver(() => {
      if (frame) return
      frame = requestAnimationFrame(() => {
        frame = 0
        adopt(document)
      })
    })
    mutations.observe(document.body, { childList: true, subtree: true })
    return () => {
      mutations.disconnect()
      cancelAnimationFrame(frame)
    }
  }, [])

  return null
}
